import React, { Component } from 'react'
import { Grid, Cell } from 'react-mdl'
import logo4 from '../Components/logo4.jpeg'
import Education from '../Components/education';
import Experience from './experience';
import Skills from './Skills';

class Resume extends Component {
    render() {
        return (
            <div>
                <Grid>
                    <Cell col={4}>
                        <div style={{ textAlign: 'center' }}>
                            <img src={logo4} alt="logo4" style={{ height: '450px' }} />
                        </div>
                        <h2 style={{ paddingTop: '2em' }}>Fatih Hicham</h2>
                        <h4 style={{ color: 'black' }}>FULL STACK WEB DEVELOPER</h4>
                        <hr style={{ borderTop: '3px solid grey', width: '50%' }} />
                        <p>Je suis ingénieure diplômée en informatique de l'école ISGA El Jadida. J'ai la chance de pouvoir pratiquer mon métier en tant que freelancer depuis 2019.
                        </p>
                        <p>Je travaille actuellement en tant que Intégrateur web et Développeur web aussi intéressé par Les tests d'applications Desktop & Mobile.</p>
                        <p>Passionnée depuis toujours par les nouvelles technologies multimédia, je me suis lancée en développement web après mon expérience Professionel à l'entreprise Xhub L'organisateur de la grand conférence des développeurs dans la région MEA .</p>
                        <hr style={{ borderTop: '3px solid grey', width: '50%' }} />
                        <h4>Adress</h4>
                        <p>Lot Melk Cheikh, Rue: 3, Num: 15, El jadida</p>
                        <h5>phone</h5>
                        <p>(+212) 42-489-687</p>
                        <h5>Email</h5>
                        <p>Fatihhicham0@gmail.com</p>
                        <hr style={{ borderTop: '3px solid grey', width: '50%' }} />
                    </Cell>
                    <Cell className="resume-right-col" col={8}>
                        <h2>Education</h2>

                        <Education
                            startYear={2015}
                            endYear={2016}
                            schoolName="ISGA El jadida"
                            schoolDescription="5éme année INGENIERIE DES LOGICIELS ET TRAITEMENT
                            D'IMAGE à (ISGA) institut supérieure du génie appliqué El jadida ."
                        />
                        <Education
                            startYear={2011}
                            endYear={2014}
                            schoolName="High school Al Qods"
                            schoolDescription="3éme année à Institut Supérieur du Génie Appliqué Branche :
                            INGENIERIE DES SYSTEMES ET RESEAUX INFORMATIQUES Ecole D’Ingénierie de
                            système D’Informatique et D’Electronique (IGA El Jadida)."
                        />
                        <Education
                            startYear={2010}
                            endYear={2011}
                            schoolName="ISGA El jadida"
                            schoolDescription="Baccalauréat en Sciences Experimentale Au Lycée Al Qods – El
                            jadida ."
                        />
                        <hr style={{ borderTop: '3px solid #bf00ff' }} />
                        <h2>Experience</h2>
                        <Experience
                            startYear={2017}
                            endYear={2019}
                            JobName="Le premier emploi"
                            JobDescription="A Xhub societé en tan que intégrateur web & Testeur & Résponsable de la l'association Devoxx4kids"
                        />
                        <Experience
                            startYear={2019}
                            endYear={2020}
                            JobName="deuxiéme emploi"
                            JobDescription="Freelancer"
                        />
                        <hr style={{ borderTop: '3px solid #bf00ff' }} />
                        <h2>Skills</h2>
                        <Skills
                            skill="HTML5 / CSS3 / JAVASCRIPT"
                            progress={90}
                        />
                        <Skills
                            skill="NODE JS"
                            progress={80}
                        />
                        <Skills
                            skill="REACT JS"
                            progress={90}
                        />
                        <Skills
                            skill="Driven Test Developpement"
                            progress={70}
                        />
                        <Skills
                            skill="Wordpress"
                            progress={85}
                        />
                    </Cell>
                </Grid>
            </div>
        )
    }
}
export default Resume;